// extracted by mini-css-extract-plugin
export default {"root":"SelectablePeople_root__k2Jk0","normal":"SelectablePeople_normal__Sq3jp","selected":"SelectablePeople_selected__PUgbP","sides":"SelectablePeople_sides__+tkhB"};